<template>
  <section class="app-main">
    <transition name="fade" mode="out-in">
      <router-view :key="viewKey"></router-view>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    viewKey() {
      return this.$route.fullPath || this.$route.path
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue